<template>
  <div>
    <b-breadcrumb :items="breadcrumbItems"></b-breadcrumb>

    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-sm-6">
            <h4 qid="lm-view-page-title" class="mb-3">
              {{ logManagement.name }}
            </h4>
            <div class="mb-2">
              <span v-if="getGuide('log_management')">
                <GuideButton :guide="getGuide('log_management')"></GuideButton>
              </span>
            </div>
          </div>

          <div class="col-md-6 text-right" qid="view-lm-modified">
            <div class="mb-4">
                <span class="h6 ml-3">
                <span v-if="isGranted([permissions.LOG_MANAGEMENT_EDIT, permissions.LOG_MANAGEMENT_EDIT_OWN], logManagement.created_by) && (!getClient.parent || (getClient.parent && logManagement.partition))"
                      class="btn btn-edit"
                      qid="edit-lm-button"
                      @click="showEditLMModal(logManagement)"
                >
                  <font-awesome-icon icon="pen"/>
                </span>
                <span v-if="isGranted([permissions.LOG_MANAGEMENT_DELETE, permissions.LOG_MANAGEMENT_DELETE_OWN], logManagement.created_by) && (!getClient.parent || (getClient.parent && logManagement.partition))"
                      class="btn btn-delete"
                      qid="delete-lm-button"
                      @click="showConfirmDeleteModal(logManagement)"
                >
                  <font-awesome-icon icon="trash-alt"/>
                </span>
              </span>
            </div>
            <div>
              <span>{{ $t('table.last_updated') }}</span>
              <span class="ml-2 text-muted small" qid="view-lm-modified-date">
              {{ logManagement.updated_at | formatDate }}
            </span>
              <Avatar v-if="logManagement.updated_by" :object="logManagement.updated_by" size="xs" class="ml-3 mr-2"></Avatar>
              <span v-if="logManagement.updated_by" qid="view-lm-modified-by">
              {{ logManagement.updated_by.name }}
            </span>
            </div>
          </div>

        </div>
      </div>
    </div>

    <b-tabs class="mt-3">

      <!-- First tab -->
      <b-tab :title="$t('maintenance.log_management.tab.basic_info')" active>
        <div class="card">
          <div class="card-body">
            <div class="content-view-body">
              <br>
              <div class="mt-3">
                <p class="text-dark">
                  {{ $t('maintenance.log_management.create.log_collection_label') }}
                </p>
                <hr>
                <p>
                  <span v-if="logManagement.log_collection == 1" qid="lm-log-collection-yes">
                    {{ $t('system.yes') }}
                  </span>
                  <span v-if="logManagement.log_collection == 0" qid="lm-log-collection-no">
                    {{ $t('system.no') }}
                  </span>
                </p>
                <br>
              </div>
              <div class="mt-3">
                <p class="text-dark">
                  {{ $t('maintenance.log_management.create.log_analysis_label') }}
                </p>
                <hr>
                <p>
                  <span v-if="logManagement.log_analysis == 1" qid="lm-log-analysis-yes">
                    {{ $t('system.yes') }}
                  </span>
                  <span v-if="logManagement.log_analysis == 0" qid="lm-log-analysis-no">
                    {{ $t('system.no') }}
                  </span>
                </p>
                <br>
              </div>
            </div>
          </div>
        </div>
      </b-tab>

      <!-- Second tab -->
      <b-tab :title="$t('maintenance.log_management.tab.linked_systems')" class="mt-3">
        <SystemsTable :object="logManagement"></SystemsTable>
      </b-tab>
    </b-tabs>


    <!-- Edit information obligation modal template -->
    <b-modal ref="edit-log-management" hide-footer>
      <div class="d-block text-center">
        <h4 qid="update-lm-title">
          {{ $t('maintenance.log_management.update.title') }}
        </h4>
      </div>
      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="edit-lm-error"
      >
        {{ error }}
      </b-alert>
      <b-form @submit="editLMFormSubmit" qid="create-lm-form">
        <div class="form-container">
          <b-form-group>
            <label qid="edit-lm-name-label">
              {{ $t('maintenance.log_management.create.name_label') }}
            </label>
            <b-form-input
              qid="edit-lm-form-name"
              type="text"
              v-model="lmForm.name"
              :maxLength="255"
              required
              :placeholder="$t('maintenance.log_management.create.name_placeholder')"
            ></b-form-input>
          </b-form-group>
          <b-form-group>
            <label qid="edit-lm-collection-label">
              {{ $t('maintenance.log_management.create.log_collection_label') }}
            </label>
            <b-form-radio-group
              v-model="lmForm.log_collection"
              :options="radioOptions"
              qid="edit-lm-form-collection"
            ></b-form-radio-group>
          </b-form-group>
          <b-form-group>
            <label qid="edit-lm-analysis-label">
              {{ $t('maintenance.log_management.create.log_analysis_label') }}
            </label>
            <b-form-radio-group
              v-model="lmForm.log_analysis"
              :options="radioOptions"
              qid="edit-lm-form-analysis"
            ></b-form-radio-group>
          </b-form-group>
        </div>
        <div class="text-right">
          <b-button class="mt-3"
                    variant="secondary"
                    @click="hideEditLMModal"
                    qid="edit-lm-cancel-button"
          >
            {{ $t('maintenance.log_management.create.cancel') }}
          </b-button>
          <b-button type="submit"
                    class="mt-3 ml-3"
                    variant="success"
                    :disabled="buttonDisabled"
                    qid="edit-lm-submit-button"
          >
            <span v-if="buttonDisabled" class="mr-1">
              <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
            </span>
            {{ $t('maintenance.log_management.create.submit') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>


    <!-- Delete information obligation confirm modal template -->
    <b-modal ref="delete-log-management" hide-footer>
      <div class="d-block text-center">
        <h4 qid="delete-lm-title">
          {{ $t('maintenance.log_management.delete.title') }}
        </h4>
      </div>
      <h5 class="text-center">
        {{ $t('maintenance.log_management.delete.description') }} {{ itemToDelete.name }}
      </h5>
      <h5 class="text-center">
        {{ $t('maintenance.log_management.delete.are_you_sure') }}
      </h5>
      <div class="text-center">
        <b-button class="mt-3"
                  variant="secondary"
                  @click="hideConfirmDeleteModal"
                  qid="delete-lm-cancel-button"
        >
          {{ $t('maintenance.log_management.delete.cancel') }}
        </b-button>
        <b-button @click="confirmDeleteLM(itemToDelete)"
                  class="mt-3 ml-3"
                  variant="success"
                  qid="delete-lm-submit-button"
                  v-if="isGranted([permissions.LOG_MANAGEMENT_DELETE, permissions.LOG_MANAGEMENT_DELETE_OWN], itemToDelete.created_by) && (!getClient.parent || (getClient.parent && itemToDelete.partition))"
        >
          {{ $t('maintenance.log_management.delete.submit') }}
        </b-button>
      </div>
    </b-modal>

  </div>
</template>

<script>
import piincHttp from '@/util/configureAxios.js'
import {config} from '@/config.js'
import Avatar from '@/components/Avatar.vue';
import SystemsTable from '@/views/LogManagement/SystemsTable.vue';
import GuideButton from '@/components/guide/GuideButton.vue';


export default {
  name: 'LogManagementView',
  data: function() {
    return {
      breadcrumbItems: [
        {
          text: this.$t('dashboard.title'),
          to: '/'
        },
        {
          text: this.$t('maintenance.title'),
          to: '/maintenance'
        },
        {
          text: this.$t('maintenance.log_management.title'),
          to: '/maintenance/log-management'
        }
      ],
      logManagement: {},
      itemToDelete: {},
      lmForm: {
        name: '',
        log_collection: '',
        log_analysis: '',
        client:'',
      },
      error: '',
      radioOptions: [
        {text: this.$t('system.yes'), value: 1},
        {text: this.$t('system.no'), value: 0}
      ],
      buttonDisabled: false,
      myGuides: [],
    }
  },
  computed: {
    rows() {
      // Use computed value for rows because of dynamic update
      return this.totalRows
    },
    getClient() {
      return this.$store.state.client
    }
  },
  watch: {
    getClient: function (newValue, oldValue) {
      if (newValue && oldValue && newValue.slug !== oldValue.slug) {
        this.goToList()
      }
    }
  },
  components: {
    Avatar,
    SystemsTable,
    GuideButton
  },
  methods: {
    goToList() {
      this.$router.push('/maintenance/log-management')
    },
    getGuide(code) {
      let existingGuide = _.find(this.myGuides, function(object) {
        return object.scope == code && object.type == 'Maintenance'
      });
      return existingGuide
    },
    loadGuides(code) {
      let self = this;
      let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';

      piincHttp.get('guides', { params:
        {
          per_page: 1,
          language: 'en',
          type: 'Maintenance',
          scope: code,
          client: this.getClient.slug
        }
      }).then(function(response) {
        if (response.data.items.length) {
          self.myGuides.push(response.data.items[0])
        }
      }, function() {});
    },
    loadContent() {
      let self = this;
      piincHttp.get('log-managements/' + this.$route.params.slug, { params:
        {
          client: this.getClient.slug
        }
      }).then(function(response) {
        self.logManagement = response.data;
        // Push Information obligation name in breadcrumb array
        self.breadcrumbItems.push({text: self.logManagement.name, active: true});
      }, function() {});
    },
    getUserAvatar(user){
      if (user && user.avatar) {
        return user.avatar;
      } else {
        return require('@/assets/avatar.png');
      }
    },
    showConfirmDeleteModal(object) {
      this.itemToDelete = object
      this.$refs['delete-log-management'].show()
    },
    hideConfirmDeleteModal() {
      this.itemToDelete = {}
      this.$refs['delete-log-management'].hide()
    },
    confirmDeleteLM(object) {
      let self = this;
      piincHttp.delete('log-managements/' + object.slug).then(function() {
        self.hideConfirmDeleteModal();
        self.goToList();
        // Trigger toastr message after modal close
        self.$toastr('success', self.$t('maintenance.log_management.delete.success'))
      }, function() {});
    },
    showEditLMModal(object) {
      this.lmForm.slug = object.slug;
      this.lmForm.name = object.name;
      this.lmForm.log_collection = object.log_collection;
      this.lmForm.log_analysis = object.log_analysis;
      this.$refs['edit-log-management'].show()
    },
    hideEditLMModal() {
      this.$refs['edit-log-management'].hide()
    },
    editLMFormSubmit(evt) {
      this.buttonDisabled = true;
      var moment = require('moment');
      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;
      evt.preventDefault();
      this.lmForm.client = this.getClient.slug;

      piincHttp.put('log-managements/' + this.lmForm.slug, this.lmForm).then(function(response) {
        self.hideEditLMModal();
        self.buttonDisabled = false;
        // If slug is not changed, just reload content
        if (response.data.slug === self.logManagement.slug) {
          // Remove last item in breadcrumbs, because it will be added again on load content
          self.breadcrumbItems.pop();
          self.loadContent();
        } else {
          // If slug changed, reload state with new param
          self.$router.push({ name: 'maintenance.log_management.view', params: { slug: response.data.slug }})
        }
        self.$toastr('success', self.$t('maintenance.log_management.update.success'))
      }, function(error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
        }
      })
    }
  },
  created () {
    this.loadContent()
    this.loadGuides('log_management');
  }
}
</script>
